import { ColumnsType, DeleteIcon } from '@/components/_common';
import {
  useDeleteCertificate,
  useInvoiceSettingCertificates,
} from '@/core/domain/invoice/certificate/Certificate.hooks';
import { InvoiceSettinsCertificates } from '@/core/domain/invoice/certificate/Certificate.types';
import { Modal, Table } from 'antd';
import moment from 'moment';

import { useIntl } from 'react-intl';

const SettingsFiscalList = () => {
  const intl = useIntl();

  const { data, isLoading } = useInvoiceSettingCertificates();

  const deleteCertificate = useDeleteCertificate();

  const columns: ColumnsType<InvoiceSettinsCertificates> = [
    {
      title: 'Nome',
      dataIndex: 'name',
      ellipsis: true,
      width: '50%',
    },
    {
      title: 'Registro',
      dataIndex: 'registrationDate',
      ellipsis: true,
      render: (value) =>
        value ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
    },
    {
      title: 'Validade',
      dataIndex: 'expirationDate',
      ellipsis: true,
      render: (value) =>
        value ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
    },
    {
      width: '10%',
      align: 'right',
      fixed: 'right',
      title: intl.formatMessage({ id: 'commons.list.header.action' }),
      render: (_, row) => (
        <DeleteIcon
          onClick={() => {
            Modal.confirm({
              title: 'Deseja realmente excluir o certificado digital?',
              content: `Ao remover o certificado digital, a recuperação do mesmo não poderá ser feita. Ainda sim deseja coninuar?`,
              onOk: async () => await deleteCertificate.mutateAsync(row.id),
            });
          }}
        />
      ),
    },
  ];

  return (
    <Table<InvoiceSettinsCertificates>
      className="table-small"
      dataSource={data}
      columns={columns}
      pagination={false}
      loading={isLoading}
    />
  );
};

export default SettingsFiscalList;
